var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"slideright"}},[(_vm.doShowDrawer)?_c('div',{ref:"sidebar",staticClass:"q-summit-sidebar-drawer__wrapper"},[_c('v-navigation-drawer',{staticClass:"q-summit-sidebar-drawer",attrs:{"light":"","right":"","width":"350px","mobile-break-point":0}},[_c('QSummitSidebar')],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }